/**
 * lecture에서도 동일하게 사용하는 함수
 */
function getStableHash(str: string): number {
  let hash = 2166136261; // FNV offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return hash >>> 0; // 부호 없는 32비트 정수로 변환
}

export function getDeviceTokenStorageKey(userId: number) {
  const storageKey = getStableHash(userId.toString());
  const storageKeyWithPrefix = `deviceToken_${storageKey}`;
  return storageKeyWithPrefix;
}
